import { loadConfig, getConfig } from './src/config';

export const onClientEntry = () => {
  return loadConfig().then(() => {
    const { careerCaptchaKey } = getConfig();

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${careerCaptchaKey}`;
      script.async = true;
      script.onload = () => {
        console.log('reCAPTCHA enterprise script loaded');
        resolve();
      };
      document.head.appendChild(script);
    });
  });
};
